module.exports = __webpack_public_path__ + "img/nonEditable_info1.085b81d9.png";